import script from "./BookSpaceWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BookSpaceWidget.vue?vue&type=script&setup=true&lang=js"

import "./BookSpaceWidget.vue?vue&type=style&index=0&id=23589dc2&lang=scss"

const __exports__ = script;

export default __exports__